import intlTelInput from 'intl-tel-input';

const telInstances = new WeakMap<HTMLInputElement, ReturnType<typeof intlTelInput>>();

function initTelInput(input: HTMLInputElement) {
	if (input.dataset.itiInitialized) return;
	input.dataset.itiInitialized = 'true';

	const iti = intlTelInput(input, {
		loadUtils: () => import("intl-tel-input/utils"),
		initialCountry: "fr",
		separateDialCode: true,
		strictMode: true,
		countrySelectorMode: "DROPDOWN",
	});
	telInstances.set(input, iti);

	input.addEventListener('open:countrydropdown', () => {
		const searchInput = document.querySelector('.iti__search-input');
		if (searchInput) {
			searchInput.classList.add('form-control');
		}
	});
}

// Écouté sur `document` en phase de capture : s'exécute toujours avant les listeners "submit"
// posés directement sur le <form> (qui, elles, s'exécutent dans l'ordre d'ajout puisque le
// formulaire est la cible de l'événement — capture:true sur le form lui-même ne garantit rien).
document.addEventListener('submit', (event) => {
	const form = event.target;
	if (!(form instanceof HTMLFormElement)) return;
	form.querySelectorAll<HTMLInputElement>("input[type='tel']").forEach((input) => {
		const iti = telInstances.get(input);
		if (!iti) return;
		// On applique toujours le format international dès qu'il y a une saisie,
		// même si isValidNumber() est false (ex: numéro jugé incomplet/invalide pour
		// le pays sélectionné) — sinon la valeur brute locale part telle quelle.
		if (input.value.trim() !== '') {
			input.value = iti.getNumber();
		}
	});
}, { capture: true });

document.querySelectorAll<HTMLInputElement>("input[type='tel']").forEach(initTelInput);

new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		mutation.addedNodes.forEach((node) => {
			if (!(node instanceof HTMLElement)) return;
			if (node.matches("input[type='tel']")) {
				initTelInput(node as HTMLInputElement);
			}
			node.querySelectorAll<HTMLInputElement>("input[type='tel']").forEach(initTelInput);
		});
	});
}).observe(document.body, { childList: true, subtree: true });
